
import { forwardRef } from "react";
import { Box } from "lucide-react";
import type { SceneObject } from "@mind-sands/shared";
import { cn } from "@/lib/utils";

// ─── SceneObjectListItem ────────────────────────────────────

interface SceneObjectListItemProps {
  object: SceneObject;
  displayName: string;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export const SceneObjectListItem = forwardRef<
  HTMLDivElement,
  SceneObjectListItemProps
>(function SceneObjectListItem(
  { object, displayName, isSelected, onSelect },
  ref,
) {
  return (
    <div
      ref={ref}
      onClick={() => onSelect(object.id)}
      className={cn(
        "flex items-center gap-2 px-3 py-2 cursor-pointer transition-colors select-none",
        isSelected
          ? "bg-healing-50 border-l-2 border-healing-500"
          : "border-l-2 border-transparent hover:bg-sands-50",
      )}
    >
      <Box className="w-3.5 h-3.5 text-sands-400 shrink-0" />
      <span
        className="text-xs font-medium text-sands-700 truncate"
        title={displayName}
      >
        {displayName}
      </span>
    </div>
  );
});
